import { Steps as AntdSteps, StepsProps } from 'antd'
import React from 'react'
import styled from 'styled-components'

export const Steps: React.FC<StepsProps> = (props) => {
  return <StyledSteps {...props} />
}

const StyledSteps = styled(AntdSteps)`
  &&& {
    .ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-icon {
      background: ${(props) => props.theme.brand._1};
      border-color: ${(props) => props.theme.brand._2};
    }
    .ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-icon {
      border-color: ${(props) => props.theme.brand._4};
      background-color: ${(props) => props.theme.brand._4};
    }
    .ant-steps-item-finish
      > .ant-steps-item-container
      > .ant-steps-item-content
      > .ant-steps-item-title::after {
      background-color: ${(props) => props.theme.brand._2};
    }
    .ant-steps-item-finish
      > .ant-steps-item-container
      > .ant-steps-item-icon
      > .ant-steps-icon {
      color: ${(props) => props.theme.brand._2};
    }
    .ant-steps-item-wait
      > .ant-steps-item-container[role='button']
      > .ant-steps-item-content:hover {
      border-color: ${(props) => props.theme.brand._2};
    }
    .ant-steps-item-container[role='button']:hover .ant-steps-item-icon {
      border-color: ${(props) => props.theme.brand._2} !important;
      & .ant-steps-icon {
        color: ${(props) => props.theme.brand._2} !important;
      }
    }
    .ant-steps-item-container[role='button']:hover .ant-steps-item-title {
      color: ${(props) => props.theme.brand._2} !important;
    }
  }
`
